<ng-container *ngIf="{
  system: selectedSystem$ | async,
  connextData: connextData$ | async,
  } as resolved">
  <ng-container *ngIf="checkSystemPortability$ | async as portability" >
    <section
      *ngIf="portability === Portability.PORTABLE && !onlyAdvice"
      id="plant-portable"
      class="custom-block fx-row fx-align-center bg-accent-100 border-accent-300 border-1 w-full">
      <customer-title-content
        class="fx-g-1"
        [title]="labels.plantIsPortable"
        [content]="labels.plantPortableDescription">
      </customer-title-content>
      <customer-simple-button
        *ngIf="resolved.system"
        class="min-w-20 text-white d-contents"
        mat-button
        [label]="labels.plantIsPortableButton"
        [action]="portPlant(resolved.system, resolved.connextData)">
      </customer-simple-button>
    </section>
  </ng-container>
</ng-container>